module.exports = __webpack_public_path__ + "img/paragraph-line-1.cb1cd488.svg";